// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wKDw","label":"styles_label__2eX3D"};